import React from "react";
import { Link } from "react-router-dom";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube, FaMapMarkerAlt, FaPhone, FaEnvelope } from "react-icons/fa";
import "./footer.css";

export const Footer = (props) => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3 className="footer-title">
                <Link to="/a-propos" style={{ color: 'inherit', textDecoration: 'none' }}>À propos de nous</Link>
              </h3>
              <p className="footer-description">
                {props.data ? props.data.about : "Leader dans les solutions informatiques innovantes au Togo depuis près de 30 ans."} <Link to="/a-propos" style={{ color: 'red', fontWeight: 'bold' }}>En savoir plus</Link>
              </p>
            </div>

            <div className="footer-section">
              <h3 className="footer-title">Nos services</h3>
              <ul className="footer-links">
                <li><Link to="/services">Développement Web & Mobile</Link></li>
                <li><Link to="/services">Gestion de bases de données</Link></li>
                <li><Link to="/services">Support Technique</Link></li>
                <li><Link to="/services">Systèmes & Réseaux</Link></li>
                <li><Link to="/services">Service Commercial</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h3 className="footer-title">Contact</h3>
              <ul className="footer-contact">
                <li>
                  <FaMapMarkerAlt />
                  <span>{props.data ? props.data.address : "Agoe Telessou, Lomé, Togo"}</span>
                </li>
                <li>
                  <FaPhone style={{ transform: "rotate(90deg)" }} />
                  <span>{props.data ? props.data.phone : "+228 91 97 87 87"}</span>
                </li>
                <li>
                  <FaEnvelope />
                  <span>{props.data ? props.data.email : "togo3000informatique@gmail.com"}</span>
                </li>
              </ul>
            </div>
            {/* Social Media Links 
            <div className="footer-section">
              <h3 className="footer-title">Suivez-nous</h3>
              <div className="footer-social">
                <a href={props.data ? props.data.facebook : "/"} className="social-link">
                  <FaFacebook />
                </a>
                <a href={props.data ? props.data.twitter : "/"} className="social-link">
                  <FaTwitter />
                </a>
                <a href={props.data ? props.data.linkedin : "/"} className="social-link">
                  <FaLinkedin />
                </a>
                <a href={props.data ? props.data.instagram : "/"} className="social-link">
                  <FaInstagram />
                </a>
                <a href={props.data ? props.data.youtube : "/"} className="social-link">
                  <FaYoutube />
                </a>
              </div>
            </div>
            */}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} Togo 3000 Informatique. Tous droits réservés.
            </p>
            {/*<ul className="legal-links">
              <li><Link to="/confidentialite">Confidentialité</Link></li>
              <li><Link to="/conditions">Conditions</Link></li>
              <li><Link to="/mentions-legales">Mentions légales</Link></li>
            </ul>*/}
          </div>
        </div>
      </div>
    </footer>
  );
};
